import { connect } from 'react-redux';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import I18n from 'I18n';
import Routes from 'web-interactives-dashboard-ui/components/Routes';
import ProhibitedDashboard from 'web-interactives-dashboard-ui/components/ProhibitedDashboardPage';
import ModalsContainer from './ModalsContainer';
import history from 'web-interactives-dashboard-ui/history';
import { getHasAccessToWebInteractives } from 'web-interactives-dashboard-ui/selectors/auth';
import { getBaseRoute } from 'web-interactives-dashboard-ui/selectors/appStateSelectors';
import { OnboardingTour, OnboardingTourContext } from '../components/tours/OnboardingTour';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class AppContainer extends Component {
  constructor(props) {
    super(props);
    history.configure(props.history);
  }
  componentDidMount() {
    this.setDocumentTitle();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.route !== this.props.route) {
      this.setDocumentTitle();
    }
  }
  setDocumentTitle() {
    document.title = I18n.text(`documentTitle.${this.props.route || 'manage'}`);
  }
  render() {
    if (!this.props.hasAccess) {
      return /*#__PURE__*/_jsx(ProhibitedDashboard, {});
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(OnboardingTourContext, {
        children: [/*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(ModalsContainer, {}), /*#__PURE__*/_jsx(Routes, {})]
      })
    });
  }
}
export default withRouter(connect(state => ({
  hasAccess: getHasAccessToWebInteractives(state),
  route: getBaseRoute(state)
}))(AppContainer));